import { MdSearch } from "react-icons/md";
import { CiExport } from "react-icons/ci";
import { BsPlus } from "react-icons/bs";

const GlobalSearchFilter = ({
  title,
  showAddButton = true,
  showExportButton = true,
  searchKeyword,
  onSearchChange,
  userType,
  onUserTypeChange,
  selectedCountry,
  onCountryChange,
  onAddClick,
  onExportClick,
  countries = [],
  userTypeOptions = [
    { value: "", label: "All Types" },
    { value: "TEACHER", label: "Teacher" },
    { value: "PARENT", label: "Parent" },
    { value: "OTHER", label: "Other" },
  ],
  placeholder,
  selectShow1 = false,
  selectShow2 = false,
  buttonLabel,
  showImportButton,
  onImportClick,
  showSearch = true,
  genderOption,
  selectShow3 = false,
  selectedGender,
  onGenderChange,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 p-4 bg-white    border-black/10">
        <h1 className="font-bold table-font text-xl md:text-2xl">
          {title || "User Management"}
        </h1>

        {(showAddButton || showExportButton) && (
          <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto">
            {showAddButton && (
              <button
                className="bg-[#1E5EFF] w-auto flex justify-center items-center hover:bg-blue-600 text-white px-4 py-2 rounded-md gap-2"
                onClick={onAddClick}
              >
                <BsPlus className="text-lg" />
                {buttonLabel ? buttonLabel : "Add User"}
              </button>
            )}
          </div>
        )}
      </div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 p-4 bg-white border border-black/10">
        <div className="flex flex-col gap-4 w-full md:flex-row md:items-center md:justify-between flex-wrap">
          {/* Dropdown Filters */}
          <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto">
            {/* Search Input */}
            {showSearch && (
              <div className="relative  ">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MdSearch className="w-5 h-5 text-gray-400" />
                </div>
                <input
                  className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  onChange={onSearchChange}
                  value={searchKeyword}
                  type="text"
                  placeholder={placeholder || "Search..."}
                />
              </div>
            )}
            {/* User Type */}
            {selectShow2 && (
              <select
                className="w-full sm:w-64 px-3 py-2 border border-[#D9E1EC] bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                onChange={onUserTypeChange}
                value={userType}
              >
                {userTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}

            {/* Country */}
            {selectShow1 && (
              <select
                className="w-full sm:w-64 px-3 py-2 border border-[#D9E1EC] bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                onChange={onCountryChange}
                value={selectedCountry}
              >
                <option value="">All Countries</option>
                {countries.map((country) => (
                  <option key={country._id} value={country._id} className="flex items-center">
                   <img src={country?.image} alt=""/> {country.name}
                  </option>
                ))}
              </select>
            )}

            {/* Gender */}
            {selectShow3 && (
              <select
                className="w-full sm:w-64 px-3 py-2 border border-[#D9E1EC] bg-white rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm"
                onChange={onGenderChange}
                value={selectedGender}
              >
                <option value="">All</option>
                {genderOption.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            )}
          </div>

          <div className="flex flex-col sm:flex-row gap-2 w-full md:w-auto   md:mt-0">
            {showExportButton && (
              <button
                onClick={onExportClick}
                className="w-full sm:w-auto px-4 py-1 border border-gray-400 text-gray-800 flex items-center justify-center gap-2 rounded-md hover:bg-gray-100 transition duration-200"
              >
                <CiExport className="w-5 h-5" />
                Export
              </button>
            )}
            {showImportButton && (
              <button
                onClick={onImportClick}
                className="w-full sm:w-auto px-4 py-1 border border-gray-400 text-gray-800 flex items-center justify-center gap-2 rounded-md hover:bg-gray-100 transition duration-200"
              >
                <CiExport className="w-5 h-5" />
                Import
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalSearchFilter;
